import React from "react";
import PoliUmum from "./Tables/PoliUmum";
import PoliGigi from "./Tables/PoliGigi";
import Kebidanan from "./Tables/Kebidanan";
import Laboratorium from "./Tables/Laboratorium";
import Imunisasi from "./Tables/Imunisasi";
import IvaJadwal from "./Tables/IvaJadwal";

export default function Schedule() {
  return (
    <div className="w-5/6 mx-auto flex flex-col items-center my-24">
      <h1
        className="text-2xl sm:text-4xl 2xl:text-5xl font-bold text-center mb-5"
        id="schedules"
      >
        Jadwal Pelayanan
      </h1>
      <p className="text-center text-gray-500 my-5 mb-10">
        Berikut jadwal pelayanan FKTP Klinik Mora Medika
      </p>
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Poli Umum
      </p>
      <PoliUmum />
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Poli Gigi
      </p>
      <PoliGigi />
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Kebidanan
      </p>
      <Kebidanan />
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Laboratorium
      </p>
      ​<Laboratorium />
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Imunisasi
      </p>
      <Imunisasi />
      <p className=" p-2 2xl:text-lg font-semibold my-2 border-2  border-blue-200  rounded-lg  ">
        Iva
      </p>
      <IvaJadwal />
    </div>
  );
}
